import TripItemRailRecommendationModule from './trip-item-rail-recommendation/trip-item-rail-recommendation-module';
import TripItemEuRailRecommendationModule from './trip-item-eurail-recommendation/trip-item-eurail-recommendation-module';
import TripItemFlightRecommendationModule from './trip-item-flight-recommendation/trip-item-flight-recommendation-module';
import TripItemRecommendationService from './trip-item-recommendation-service';
import TripItemTaxiModule from '../trip-item-taxi/trip-item-taxi-module';
import TripItemBusModule from '../trip-item-bus/trip-item-bus-module';
import TripItemFerryModule from '../trip-item-ferry/trip-item-ferry-module';
import TripItemFlightModule from './trip-item-flight-recommendation/trip-item-flight-recommendation-module';

const MODULE_NAME = 'app.trip.item-recommendation';
const module = angular.module(MODULE_NAME, [
        TripItemRailRecommendationModule,
        TripItemEuRailRecommendationModule,
        TripItemFlightModule,
        TripItemTaxiModule,
        TripItemBusModule,
        TripItemFerryModule,
        TripItemFlightRecommendationModule,
    ])
    .service('tripItemRecommendationService', TripItemRecommendationService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-item-recommendation/trip-item-recommendation-module.js